webpackJsonp([97121786907997],{

/***/ 1132:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.query = undefined;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactHelmet = __webpack_require__(8);
	
	var _headerManager = __webpack_require__(31);
	
	var _screener = __webpack_require__(256);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ConsumerScreener = function (_React$PureComponent) {
		_inherits(ConsumerScreener, _React$PureComponent);
	
		function ConsumerScreener() {
			var _temp, _this, _ret;
	
			_classCallCheck(this, ConsumerScreener);
	
			for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
				args[_key] = arguments[_key];
			}
	
			return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$PureComponent.call.apply(_React$PureComponent, [this].concat(args))), _this), _this.componentDidMount = function () {
				_headerManager.HeaderManager.headerProperties = {
					back: false,
					subheader: 'Questionnaire'
				};
			}, _temp), _possibleConstructorReturn(_this, _ret);
		}
	
		ConsumerScreener.prototype.render = function render() {
			var pageSettings = this.props.data.page.edges[0].node;
			var resultPages = this.props.data.resultPages.edges[0].node;
			var pages = this.props.data.screener.edges[0].node.pages;
	
	
			return _react2.default.createElement(
				_react2.default.Fragment,
				null,
				_react2.default.createElement(_reactHelmet.Helmet, { title: 'Screener - For Myself' }),
				_react2.default.createElement(_screener.Screener, {
					location: this.props.location,
					type: 'Consumer',
					resultTiles: pageSettings,
					pages: pages,
					resultPages: resultPages,
					headerManager: _headerManager.HeaderManager
				})
			);
		};
	
		return ConsumerScreener;
	}(_react2.default.PureComponent);
	
	ConsumerScreener.propTypes = {
		location: _propTypes2.default.shape({
			search: _propTypes2.default.string.isRequired
		}).isRequired,
	
		data: _propTypes2.default.shape({
			page: _propTypes2.default.shape({
				edges: _propTypes2.default.arrayOf(_propTypes2.default.shape({
					node: _propTypes2.default.shape({
						left_heading: _propTypes2.default.string,
						left_body: _propTypes2.default.string,
						left_link_text: _propTypes2.default.string,
						left_link_url: _propTypes2.default.string,
						right_heading: _propTypes2.default.string,
						right_body: _propTypes2.default.string,
						right_link_text: _propTypes2.default.string,
						right_link_url: _propTypes2.default.string
					}).isRequired
				})).isRequired
			}).isRequired,
	
			screener: _propTypes2.default.shape({
				edges: _propTypes2.default.arrayOf(_propTypes2.default.shape({
					node: _propTypes2.default.shape({
						pages: _propTypes2.default.arrayOf(_propTypes2.default.shape({
							question: _propTypes2.default.string.isRequired,
							description: _propTypes2.default.string.isRequired,
							answers: _propTypes2.default.arrayOf(_propTypes2.default.shape({
								name: _propTypes2.default.string.isRequired,
								value: _propTypes2.default.string.isRequired
							}))
						})),
	
						results: _propTypes2.default.arrayOf(_propTypes2.default.shape({
							rating: _propTypes2.default.string,
							heading: _propTypes2.default.string,
							body: _propTypes2.default.string,
							button_text: _propTypes2.default.string,
							button_url: _propTypes2.default.string
						}))
					}).isRequired
				})).isRequired
			}).isRequired,
	
			resources: _propTypes2.default.shape({
				edges: _propTypes2.default.arrayOf(_propTypes2.default.shape({
					node: _propTypes2.default.any
				}))
			})
		}).isRequired
	};
	exports.default = ConsumerScreener;
	var query = exports.query = '** extracted graphql fragment **';

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-screener-for-myself-index-js-2c5f6d4c7a19d8c88619.js